import React, { useMemo, useState } from 'react';
import { Card, Form, Row, Col, Button, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { FaSearch } from 'react-icons/fa';


const FiltrosBusca = ({
  onBuscar,
  loading,
  somenteLotesQuitados,
  onChangeSomenteLotesQuitados,
}) => {
  const empreendimentosRedux = useSelector((state) => state.empreendimentos);
  const [empSelecionado, setEmpSelecionado] = useState(null);
  const [quadra, setQuadra] = useState('');
  const [lote, setLote] = useState('');

  const empreendimentos = useMemo(
    () => (empreendimentosRedux && empreendimentosRedux.sort
      ? empreendimentosRedux.sort
      : []).map((item) => ({
      value: item.codigo,
      label: `${item.codigo} - ${item.descricao}`,
    })),
    [empreendimentosRedux]
  );

  const loadingEmp = empreendimentos.length === 0;

  const handleBuscar = () => {
    if (!empSelecionado) {
      toast.warn('Selecione um empreendimento');
      return;
    }
    onBuscar({
      codigo_familia: empSelecionado.value,
      quadra: quadra.trim() || null,
      lote: lote.trim() || null,
      somente_lotes_quitados: somenteLotesQuitados,
    });
  };

  return (
    <Card className="mb-3">
      <Card.Header as="h6" className="bg-light">
        Filtros
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={5}>
            <Form.Group>
              <Form.Label>Empreendimento</Form.Label>
              <Select
                styles={customStyles}
                components={{ DropdownIndicator }}
                options={empreendimentos}
                value={empSelecionado}
                onChange={setEmpSelecionado}
                placeholder="Selecione..."
                isClearable
                isLoading={loadingEmp}
                isDisabled={loadingEmp}
                noOptionsMessage={() => 'Nenhum empreendimento'}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Quadra</Form.Label>
              <Form.Control
                type="text"
                maxLength={3}
                value={quadra}
                onChange={(e) => setQuadra(e.target.value)}
                placeholder="Quadra"
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Lote</Form.Label>
              <Form.Control
                type="text"
                maxLength={3}
                value={lote}
                onChange={(e) => setLote(e.target.value)}
                placeholder="Lote"
              />
            </Form.Group>
          </Col>
          <Col md={3} className="d-flex align-items-center mt-3">
            <Form.Check
              type="checkbox"
              label="Somente lotes quitados"
              checked={somenteLotesQuitados}
              onChange={(e) => onChangeSomenteLotesQuitados(e.target.checked)}
              className="mr-3 mb-1"
            />
          </Col>
        </Row>
        <Row className="mt-3 justify-content-end">
          <Col md="auto">
            <Button
              variant="primary"
              onClick={handleBuscar}
              disabled={loading || loadingEmp}
            >
              {loading ? <Spinner animation="border" size="sm" className="mr-1" /> : <FaSearch className="mr-1" />}
              Buscar
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default FiltrosBusca;
